import React from "react";
import QuizContent from "../shared/QuizContent";
import QuizTitle from "../shared/QuizTitle";
import QuizOptions from "../shared/QuizOptions";
import QuizOption from "../shared/QuizOption";
import { getQuizOptions } from "../../utils/quizOptions";

const Step3 = ({ onAnswer }) => {
  const quizOptions = getQuizOptions("useAI");

  const handleOptionClick = (value) => {
    onAnswer("useAI", value);
  };

  return (
    <QuizContent className="gridContent">
      <QuizTitle className="gridTitle">How often do you use AI in your daily life?</QuizTitle>
      <QuizOptions className="gridOptions">
        {quizOptions.map((option) => (
          <QuizOption
            key={option.value}
            value={option.value}
            name="useAI"
            onClick={handleOptionClick}
            hasIcon={option.hasIcon}
            defaultChecked={option.defaultChecked}
          >
            {option.hasIcon && (
              <picture>
                <img
                  src={option.image}
                  className="option-icon"
                  alt={option.alt}
                />
              </picture>
            )}
            <div>
              <p>
                <strong>{option.text}</strong>
              </p>
            </div>
          </QuizOption>
        ))}
      </QuizOptions>
    </QuizContent>
  );
};

export default Step3;
